export const formStyles = (variant) => ({
  padding: variant === 'reduced' ? 'xxs' : variant.includes('Modal') ? 0 : 'sm',
  backgroundColor: 'white',
  maxWidth: [500, 'none'],
  position: 'relative',
  border: ({ colors = {} }) => `1px solid ${colors.white}`,
  mx: 'auto',

  borderRadius: 8,
  '& .element-hidden': {
    display: 'none !important'
  }
})

export const blackFriday = {
  boxShadow: '0px 4px 8px rgba(20, 20, 36, 0.08)'
}

export const addressMatcherContainer = {
  mb: 'sm',
  minHeight: '56px',
  '& [data-error]:not(:focus), & [data-error]:focus': {
    outline: 'none',
    boxShadow: '0 0 0 2px #F94549',
    borderColor: '#141424',
    borderWidth: '2px',
    height: 56
  }
}

export const inputWrapper = {
  '& > div': {
    zIndex: 2
  },
  '& > div input._spark_input_empty:focus': {
    py: 14
  },
  '& > div input._spark_input_empty:not(:focus)': {
    py: 15
  }
}

export const spacingTop = {
  mt: 'base'
}

export const formButtonReducedHomepage = {
  width: '100%',
  maxHeight: 56,
  height: 56,
  m: 0,
  '&& > span': { display: 'block' }
}

export const formButtonReducedArrow = {
  ml: 0,
  '@media screen and (max-width: 320px)': {
    ml: -12
  }
}

export const formBottomLink = { mt: 'sm', fontSize: '12px !important' }
